import { SCHEMA_VERSION } from './schema';

export function slugify(text) {
  return (
    String(text || '')
      .toLowerCase()
      .replace(/[^\w\- ]+/g, '')
      .trim()
      .replace(/\s+/g, '-') || 'roadmap'
  );
}

const today = () => new Date().toISOString().slice(0, 10);

export function downloadJson(filename, data) {
  downloadBlob(filename, new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
}

export function downloadText(filename, text, type = 'text/plain') {
  downloadBlob(filename, new Blob([text], { type: `${type};charset=utf-8` }));
}

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function exportRoadmap(roadmap) {
  downloadJson(`minnimap-${slugify(roadmap.name)}-${today()}.json`, {
    app: 'minnimap',
    schemaVersion: SCHEMA_VERSION,
    exportedAt: new Date().toISOString(),
    roadmap
  });
}

export function exportAll(roadmaps) {
  downloadJson(`minnimap-backup-${today()}.json`, {
    app: 'minnimap',
    schemaVersion: SCHEMA_VERSION,
    exportedAt: new Date().toISOString(),
    roadmaps
  });
}

export function roadmapFilename(roadmap, ext) {
  return `minnimap-${slugify(roadmap.name)}-${today()}.${ext}`;
}

/** Ask for a Minni Map file (.json) or a spreadsheet export (.csv). */
export function pickRoadmapFile() {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json,.json,text/csv,.csv';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return resolve(null);
      const text = await file.text().catch(() => '');
      const isCsv = /\.csv$/i.test(file.name) || file.type === 'text/csv';
      if (isCsv) return resolve({ name: file.name, kind: 'csv', text, data: null });
      try {
        resolve({ name: file.name, kind: 'json', text, data: JSON.parse(text) });
      } catch {
        resolve({ name: file.name, kind: 'json', text, data: null });
      }
    };
    input.click();
  });
}

// Kept for anything still importing the old name.
export const pickJsonFile = pickRoadmapFile;
